import { Col, Row } from "react-bootstrap";
import { convertWeight, formatWeight } from "helpers/commonHelpers";
import { IGoodItem } from "pages/provider/QuotationDetail/QuotationType";
import usePermissions from "hooks/usePermissions";

function SubLists({ row }: any) {
  const { permissions } = usePermissions();
  const { unit_system_preferences } = JSON.parse(permissions ?? "{}");
  const { good_items } = row?.original?.data?.organization || {};

  const getWeight = (w_unit: string, weight: number) => {
    const toUnit = unit_system_preferences === "inch-lbs" ? "lbs" : "kg";
    const convertedWeight = convertWeight(weight, { fromUnit: w_unit?.toString().toLowerCase(), toUnit });
    return formatWeight(convertedWeight);
  };

  return (
    <>
      {good_items?.map((value: IGoodItem, index: number) => (
        <div key={index} className="py-3 px-4 sub-list">
          <Row className="text-primary">
            <Col xs={4} className="text-sm font-regular handling-unit-truncate">
              <span>{value?.handling_unit.charAt(0).toUpperCase() + value?.handling_unit?.slice(1)}</span>
              {value?.container_type && <span className="text-tertiary"> | {value?.container_type}</span>}
            </Col>
            <Col className="d-flex justify-content-end">{value?.units}</Col>
            <Col xs={2} className="d-flex justify-content-end weight-min-width">
              {getWeight(value?.w_unit, value?.weight)}
            </Col>
            <Col xs={4} className="d-flex justify-content-end volume-max-width">
              {formatWeight(value?.total_cbm ? value?.total_cbm.toFixed(2) : null)}
            </Col>
          </Row>
        </div>
      ))}
    </>
  );
}

export default SubLists;
